<template>
  <div
    class="burger-menu"
    @click="toggleNav"
  >
    <span class="line" />
    <span class="line" />
    <span class="line" />
  </div>
</template>

<script>
export default {
  name: 'NavBurger',
  methods: {
    toggleNav() {
      this.$store.commit('TOGGLE_NAV');
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/components/design-system/global";

.line {
  background-color: $c-boulder;
  display: block;
  height: 2px;
  margin-bottom: 0.5rem;
  transition: 0.4s;
  width: 2.2rem;

  &:last-child {
    margin-bottom: none;
  }
}

</style>
